module.exports = __webpack_public_path__ + "static/media/aws.5e42e264.svg";